import styled from 'styled-components'
import variables from '../../styles/variables'
import { TextWrapper, ColoredRectangleContainer } from '../../styles/base'


export const UsageStepsContainer = styled(ColoredRectangleContainer)`
  color: ${variables.colors.silverTree.dark};
  background: ${variables.colors.sunsetOrange.lighter};
  position: relative;
  flex: 0 1 100%; /* Fix IE layout bug */
  @media ${variables.media.sm} {
    padding: 70px 70px;
  }
`

export const Header = styled.h2`
  span {
    display: block;
  }
`

const spaceBetweenLineAndText = 25
export const UsageStepsStep = styled.div`
  padding: 0;
  margin-bottom: 12px;
  color: ${variables.colors.silverTree.dark};
  margin-left: -${spaceBetweenLineAndText}px;
  padding-left: ${spaceBetweenLineAndText}px;
  border-left: solid;
  border-color: rgba(0,0,0,0);

  transition: color .5s ease, border-color .8s ease;

  @media ${variables.media.sm} {
    margin-bottom: 24px;
  }
`

export const UsageStepsHeader = styled.div`
  font-size: 1.25rem;
  margin: 0px;
  padding: 10px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 700;
`

export const UsageStepsText = styled.p`
  margin-bottom: 0;
  padding-bottom: 10px;
  max-width: 500px;
  margin-top: 5px;

  @media ${variables.media.sm} {
    margin-top: 10px;
  }
`

export const UsageStepsSection = styled(TextWrapper)`

`

export const UsageStepsNumber = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid;
  text-align: center;
  border-radius: 50%;
  margin-right: 18px;
`

export const UsageStepsAnimationContainer = styled.div`
  height: 100%;
  padding: 0 0 0 20px;
  max-width: 350px;
`

export const CenterAnimation = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
`

export const ButtonWrapper = styled.div`
  margin-top: 30px;

  @media ${variables.media.sm} {
    margin-top: 70px;
  }
`
